/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".request-form[_ngcontent-%COMP%]   .hint[_ngcontent-%COMP%]{color:#6c757d;font-size:12px}.margin-left-10[_ngcontent-%COMP%]{margin-left:10px}.margin-top-10[_ngcontent-%COMP%]{margin-top:10px}\n/*# sourceMappingURL=customer-invoice-receipt-requests.component.css.map*/"];
export { styles as styles };
